import script from "./epc-input-wrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./epc-input-wrapper.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__